<template>
  <div>
    <b-carousel
      :autoplay="false"
      :repeat="false"
      :arrow-hover="false"
      icon-size="is-medium"
      class="pt-0"
      @change="renderReadMoreBtn"
    >
      <b-carousel-item v-if="newsLoading">
        <div class="section">
          <div class="card mx-6">
            <header class="card-header">
              <p class="card-header-title">
                <b-skeleton size="is-middle" width="40%"> </b-skeleton>
              </p>
            </header>
            <div class="card-content">
              <div class="level mb-2">
                <a class="level-item" style="width: 30%">
                  <b-skeleton
                    width="100%"
                    size="is-middle"
                    class="is-flex-grow-1"
                  >
                  </b-skeleton
                ></a>
                <a
                  class="is-pulled-right level-item is-flex-grow-0"
                  style="width: 90px"
                >
                  <b-skeleton size="is-middle" width="90px"></b-skeleton>
                </a>
              </div>
              <b-skeleton width="50%" size="is-middle"></b-skeleton>
              <b-skeleton width="70%" size="is-middle"></b-skeleton>
            </div>
          </div>
        </div>
      </b-carousel-item>

      <b-carousel-item
        v-for="(news, index) in publishedNews"
        :key="news.id"
        class="news-carousel"
      >
        <div class="card">
          <header
            class="
              card-header
              is-align-items-center
              is-justify-content-space-between
              is-flex-wrap-wrap
              px-4
              pt-3
            "
          >
            <p class="card-header-title p-0 pb-3">
              {{ news.title.toUpperCase() }}
            </p>
            <div class="pb-3">
              <news-category-tag
                v-if="news.category_id"
                :data="theCategory(news.category_id)"
              />
            </div>
          </header>
          <div class="card-content has-background-light py-1 pr-4">
            <p style="text-align: right">
              {{ showLongDate(news.created_at) }}
            </p>
          </div>
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <div
                  class="content main-content pr-5 mb-4"
                  style="height: 236px; overflow-y: hidden"
                >
                  <div v-html="news.text" :id="`news-content-${index}`" />
                </div>
                <p
                  style="text-align: right; font-size: 14px"
                  :id="`more-btn-${index}`"
                >
                  <a href="#" @click.prevent="openNewsModal(news)">
                    mehr erfahren
                  </a>
                </p>
              </div>
              <div
                class="column is-3 has-background-light is-hidden-touch"
                style="border-radius: 10px"
                v-if="news.sidebox_enabled"
                @click.prevent="handleLinkClick"
              >
                <div
                  class="content side-content"
                  style="height: 275px; overflow-y: hidden"
                  v-html="news.sidebox_text"
                />
              </div>
            </div>
          </div>
        </div>
      </b-carousel-item>
    </b-carousel>

    <b-modal
      :active.sync="isNewsModalActive"
      has-modal-card
      animation="zoom-in"
    >
      <template #default="props">
        <div class="carousel-modal modal-card">
          <header
            class="modal-card-head has-background-gold is-flex-wrap-wrap pb-0"
          >
            <p class="modal-card-title has-text-light is-flex-shrink-1 pb-4">
              {{ selectedNews.title }}
            </p>
            <div class="pb-4">
              <news-category-tag
                v-if="selectedNews.category_id"
                :data="theCategory(selectedNews.category_id)"
              />
            </div>
          </header>
          <p
            style="text-align: right; padding-right: 21px"
            class="has-background-light py-1"
          >
            {{ showLongDate(selectedNews.created_at) }}
          </p>
          <div class="modal-card-body">
            <div class="columns">
              <div class="column">
                <div class="content main-content" v-html="selectedNews.text" />
              </div>
              <div class="column is-3">
                <div
                  class="has-background-light"
                  style="border-radius: 10px"
                  v-if="selectedNews.sidebox_enabled"
                  @click.prevent="handleLinkClick"
                >
                  <div
                    class="content side-content p-4"
                    v-html="selectedNews.sidebox_text"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-card-foot is-flex is-justify-content-end">
            <b-button @click="props.close">Schließen</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import NewsCategoryTag from "@/components/editNews/NewsCategoryTag.vue";

export default {
  name: "NewsCarousel",
  components: {
    NewsCategoryTag
  },
  data() {
    return {
      selectedNews: null,
      isNewsModalActive: false
    };
  },
  computed: {
    ...mapGetters({
      news: "news/data",
      newsById: "news/dataById",
      newsLoading: "news/loading",
      theCategory: "newsCategory/dataById"
    }),
    publishedNews() {
      return this.news
        .filter(news =>
          // For admin with 'visible' prop, show only the published news,
          // For non admin skip visibility filter (since its already filtered in the backend)
          // eslint-disable-next-line implicit-arrow-linebreak
          "visible" in news ? news.visible : true
        )
        .sort((a, b) => b.created_at - a.created_at);
    }
  },
  methods: {
    showLongDate(timestamp) {
      return new Date(timestamp).toLocaleString("de-DE", { dateStyle: "long" });
    },
    openNewsModal(news) {
      this.selectedNews = news;
      this.isNewsModalActive = true;
    },
    renderReadMoreBtn(e) {
      // It takes the index of the displayed carousel to determine its read more button visibility
      Vue.nextTick().then(() => {
        const activeNews = document.querySelector(`#news-content-${e}`);
        if (!activeNews) return;
        const moreBtn = document.querySelector(`#more-btn-${e}`);
        moreBtn.style.visibility =
          activeNews.clientHeight > 235 ? "visible" : "hidden";
      });
    },
    handleLinkClick(e) {
      const clicked = e.target;

      // Bailed out when the clicked is not a link
      if (clicked.nodeName.toLowerCase() !== "a") return;

      const { href } = clicked;
      const hrefSubstr = href.split("/");
      const route = href.substring(href.indexOf(hrefSubstr[3]) - 1);

      this.$router.push(route);
    }
  },
  mounted() {
    // Render first slide's read more button
    this.renderReadMoreBtn(0);
  },
  updated() {
    // Render first slide's read more button
    this.renderReadMoreBtn(0);
  }
};
</script>

<style>
.news-carousel {
  padding: 0 4rem 3rem;
}

@media screen and (min-width: 1024px) {
  .news-carousel {
    padding: 0 6rem 3rem;
  }
  .modal-card.carousel-modal {
    width: 70vw;
  }
}

.content.main-content p {
  margin-bottom: 0;
}
.content.side-content p {
  margin-bottom: -5px;
  font-size: 14px;
}
</style>
